import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function Money(props) {
  return (
    <Svg
      width={37}
      height={37}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1048_82946)">
        <Path
          d="M15.962 34.872l-11.3-8.821a1.228 1.228 0 01-.21-1.726L22.922.777A1.232 1.232 0 0124.65.565l11.3 8.822c.536.418.63 1.19.21 1.726L17.689 34.66a1.232 1.232 0 01-1.727.211z"
          fill="#CDE0FF"
        />
        <Path
          d="M8.827 35.592L.844 23.696a1.23 1.23 0 01.338-1.707L26.066 5.33a1.23 1.23 0 011.706.336l7.983 11.896a1.23 1.23 0 01-.338 1.707l-24.884 16.66a1.23 1.23 0 01-1.706-.336z"
          fill="url(#paint0_radial_1048_82946)"
        />
        <Path
          d="M24.847 21.02a6.558 6.558 0 00-6.17-6.924 6.558 6.558 0 00-6.93 6.162 6.557 6.557 0 006.17 6.924 6.558 6.558 0 006.93-6.163z"
          fill="#fff"
        />
        <Path
          d="M4.587 19.711a5.322 5.322 0 01-1.46 7.389L.843 23.696a1.228 1.228 0 01.338-1.705l3.406-2.28zM6.549 32.196c2.45-1.64 5.764-.994 7.4 1.444l-3.415 2.286a1.232 1.232 0 01-1.707-.335l-2.278-3.395zM32.013 21.549a5.322 5.322 0 011.46-7.389l2.284 3.404a1.228 1.228 0 01-.339 1.705l-3.405 2.28zM30.05 9.064c-2.45 1.64-5.764.994-7.4-1.444l3.415-2.286a1.231 1.231 0 011.708.335l2.278 3.395z"
          fill="#346BC5"
        />
        <Path
          d="M26.535 15.657a.54.54 0 01-.3-.99l2.545-1.704a.54.54 0 01.601.898l-2.545 1.705a.539.539 0 01-.3.091zM7.52 28.387a.54.54 0 01-.302-.99l2.546-1.704a.54.54 0 01.602.899L7.82 28.296a.538.538 0 01-.3.091z"
          fill="#fff"
        />
        <Path
          d="M18.289 17.755l.01.02c.307.115.565.307.797.616l.82-.447.42.77-.81.442c.399 1.038.057 1.916-1.02 2.643l.011.02 4.065 1.09-1.797.98-4.293-1.249-.366-.672 1.048-.57c.76-.414 1.09-.889.95-1.478l-3.033 1.652-.42-.77 3.023-1.647c-.413-.428-.986-.398-1.736.01l-1.68.915-.484-.889 5.245-2.857.425.78-1.175.64z"
          fill="url(#paint1_radial_1048_82946)"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1048_82946"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-29.83038 28.08813 -26.07323 -27.6905 33.276 7.14)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1048_82946"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(98.294 1.784 16.554) scale(8.7511 7.33755)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <ClipPath id="clip0_1048_82946">
          <Path
            fill="#fff"
            transform="translate(.611 .305)"
            d="M0 0H35.8333V35.8333H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default Money
